import { Event } from "../../Global/Base/Events";
import { ValidityStateHelper } from "../UI.ElementarControls/Helpers/ValidityStateHelper";
import { createElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { INotifyDetached, IValidatable, IValidationResult } from "./ControlInterfaces";
import { PopupMenu } from "./PopupMenu";
/**
* Komponenta umožňující provádět v zobrazovat validaci nad libovolným HTML elementem
*/
export class ValidatableControl implements IValidatable, INotifyDetached {
    public validityChanged: Event<IValidatable, IValidationResult> = new Event<IValidatable, IValidationResult>();
    public isInRequiredInvalidState: boolean;
    public currentValidity: IValidationResult;

    private _element: HTMLElement;
    private _errorElement: HTMLElement;
    private _errorPopup: PopupMenu;
    private _mouseOnElement: boolean = false;
    protected _isValid: boolean = true;

    public get isValid(): boolean {
        return this._isValid;
    }

    constructor(el: HTMLElement, isEditable?: boolean) {
        this._element = el;
        this._element.classList.add("cellContainer");

        if (isEditable) {
            this._element.classList.add("editable");
        }

        this._element.addEventListener("mouseenter", () => {
            this._mouseOnElement = true;
            this._checkAndShowErrorPopup();
        });

        this._element.addEventListener("mouseleave", () => {
            this._mouseOnElement = false;
            if (this._errorPopup)
                this._errorPopup.setVisibility(false);
        });

        // nějak to nechce fungovat, zatím řešeno přes INotifyDetached
        /*const observer = new MutationObserver(mutations => {
            for (let mutation of mutations)
                if (Array.from(mutation.removedNodes).some(node => node === this._element))
                    this.detached();
        });

        observer.observe(this._element, { childList: true });*/
    }

    public validate(): boolean {
        this.setValid();
        return true;
    }

    public setValid(): void {
        this._isValid = true;
        this._element.classList.remove("invalid");

        if (this._errorPopup)
            this._errorPopup.setVisibility(false);

        this.validityChanged.trigger(this, { valid: true });
    }

    public setInvalid(locKey: string, message?: string): void {
        this._element.classList.add("invalid");

        this._isValid = false;

        if (!this._errorElement) {
            this._errorElement = createElement({ type: "div", classes: ["ErrorElement", "errDiv"], css: { display: "none" } });
            this._element.appendChild(this._errorElement);
        }

        if (message)
            this._errorElement.textContent = message;
        else if (locKey)
            this._errorElement.textContent = ValidityStateHelper.validityLocalizer.getLocalization(locKey);
        else
            this._errorElement.textContent = ValidityStateHelper.validityLocalizer.getLocalization("VAL-0");

        this._checkAndShowErrorPopup();

        this.validityChanged.trigger(this, { valid: false, invalidLocKey: locKey, invalidMessage: message });
    }

    private _checkAndShowErrorPopup(): void {
        if (this.isValid || !this._mouseOnElement)
            return;

        if (!this._errorPopup) {
            this._errorPopup = new PopupMenu(this._errorElement, false, null, null, null, null, false);
        }

        this._errorElement.style.display = "block";

        this._errorPopup.arangePopupToEditableControl(this._errorElement, this._element, false);
        this._errorPopup.setVisibility(true);
    }

    public detached(): void {
        this._mouseOnElement = false;

        // při odstranění z DOMu je potřeba odstranit i přidružený tooltip s validační hláškou
        if (this._errorPopup)
            this._errorPopup.close();
        this._errorPopup = null;
    }
}
